<div class="content-width" *ngIf="!containsError">
<div>
  <div>
       <span class="pageHeader" id="holidayHeader">
									Holiday Schedule
       </span>

  </div>
  <br><br><br>

  <div class="errorMessage" *ngIf="showErrorDiv">
    {{errHeading}} <br><br>
    <li> {{errMessage}}</li>
    <br>
    <hr class="hrStyle">
  </div>

  <form [formGroup]="searchForm" (ngSubmit)="getHolidayList()">
  <span class="adminTblAlign">
        <div class="ui-g-2 lblAlign"> Year:  </div>
        <div class="ui-g-3"> <input type="text" fmTextInput [maxLength]="4" formControlName="yearVal" (keypress)="this.utilService.numberOnly($event)"> </div>   <div
    class="ui-g-3">  <font size="2">(YYYY &gt;= 1994)</font> </div>

  </span>

  <div class="btnAlign">
    <button fmButton type="submit" [small]="true" label="Submit"   [primary]="true"
            class="dispbuttonMargin"></button>
    <button fmButton type="button" routerLink="/admin" [small]="true" label="Cancel" class="dispbuttonMargin"></button>
  </div>
  </form>
  <br>

  <div id="holTbl" class="dispTblMargin" *ngIf="showHolidayList">
    <fm-table [columns]="cols" [value]="holidayObj" [enableTableEntryTotal]="true"  >
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns">{{col.header}}</th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngFor="let col of columns" [style.width]="col.width">

            <div *ngIf="col.field === 'date'">
              {{ rowData[col.field].date | date: 'MM/dd/yyyy' : 'UTC' }}
            </div>
            <div *ngIf="col.field !== 'date'">
              {{  rowData[col.field] }}
            </div>

          </td>
        </tr>
      </ng-template>
    </fm-table>
    <b>* Exception Holidays</b>
  </div>
</div>
  <br>
</div>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
